<template>
  <v-container>
    <carga-ciclo-semestre titulo="Restablecer periodo:" :datos="periodo" />

    <v-divider />

    <v-card
      ><v-card-text>
        <v-list>
          <v-list-item-group v-model="selectedItem" active-class="blue--text">
            <v-subheader class="text-body-1 font-weight-bold"
              >RESPALDOS</v-subheader
            >
            <template v-for="respaldo in respaldos">
              <v-hover v-slot="{ hover }" :key="respaldo.id">
                <v-list-item
                  :key="respaldo.id"
                  @click="selecciona_este(respaldo)"
                >
                  <v-list-item-content :class="{ 'blue--text': hover }">
                    <v-list-item-title>
                      <span class="font-weight-bold">{{
                        respaldo.respaldo_de == "C"
                          ? "Carga Académica"
                          : "Tutorías"
                      }}</span
                      >: {{ respaldo.respaldo_nota }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      (Creado {{ respaldo.created_at }})
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-hover>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Restaurar respaldo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">{{ nota }} </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="
              dialog = false;
              selectedItem = -1;
            "
          >
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="restaura_este(backup)">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading-wait :loading="loading" />

    <v-snackbar v-model="snackbar" multi-line>
      <strong>{{ snacktext }}</strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"
          >Cerrar</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import api from "@/api";
import CargaCicloSemestre from "@/components/CargaCicloSemestre.vue";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";

export default {
  name: "Respaldo",

  components: { CargaCicloSemestre, LoadingWait },

  props: {
    periodoSeleccionado: {
      type: String,
      required: true,
    },
  },

  mixins: [gets],

  data: () => ({
    periodoActual: true,
    periodo: {},
    carga: {},
    tutorias: {},
    respaldos: null,
    loading: false,
    snackbar: false,
    snacktext: "",
    dialog: false,
    nota: "",
    backup: null,
    selectedItem: -1,
  }),

  computed: {},

  watch: {},

  methods: {
    async restaura_este(bak) {
      let info = JSON.parse(bak.respaldo_json);
      let data_1 = {
        table: bak.respaldo_de == "C" ? "cargas" : "tutorias",
        action: "patch",
        scope: "ind",
      };
      let data;
      for (let i in info) {
        data = {
          ...data_1,
          data: {
            ...info[i],
          },
        };
        await this.actualiza(data, false);
      }
      this.loading = false;
      this.dialog = false;
    },

    selecciona_este(bak) {
      this.nota =
        "¿Restaurar el respaldo de " +
        (bak.respaldo_de == "C" ? "Carga Académica" : "Tutorías") +
        " (" +
        bak.respaldo_nota +
        ")?";
      this.backup = bak;
      this.dialog = true;
    },

    async set() {
      this.loading = true;
      if (this.periodoSeleccionado == "proximo-periodo") {
        this.periodoActual = false;
      } else if (this.periodoSeleccionado == "periodo-actual") {
        this.periodoActual = true;
      }
      this.periodo = await this.get(
        "periodos",
        this.periodoActual ? "actual" : "proximo"
      );
      this.respaldos = await this.get(
        "respaldos",
        {
          periodo_id: this.periodo.id,
        },
        "created_at"
      );
      this.loading = false;
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Restablecer Carga y/o Tutorías");
    this.set();
  },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid darkgray;
}
.border-top {
  border-top: 1px solid darkgray;
}
</style>